import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  private API: string = environment.server;

  constructor(private http: HttpClient) {}

  HTTP_POST<T>(endpoint: string, data: T): Observable<any> {
    return this.http
      .post(`${this.API}${endpoint}`, data)
      .pipe(catchError(this.handleError));
  }

  HTTP_GET<T>(endpoint: string, params?: HttpParams): Observable<T> {
    return this.http
      .get<T>(`${this.API}${endpoint}`, { params })
      .pipe(catchError(this.handleError));
  }

  HTTP_PUT<T>(endpoint: string, data: T): Observable<any> {
    return this.http
      .put(`${this.API}${endpoint}`, data)
      .pipe(catchError(this.handleError));
  }

  HTTP_DELETE<T>(endpoint: string, params?: HttpParams): Observable<any> {
    return this.http
      .delete(`${this.API}${endpoint}`, { params })
      .pipe(catchError(this.handleError));
  }

  HTTP_DOWNLOAD(endpoint: string): Observable<Blob> {
    return this.http
      .get(`${this.API}${endpoint}`, { responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMsg: string;

    switch (error.status) {
      case 401:
        errorMsg = 'Tu sesión ha expirado o no tienes permisos para realizar esta acción.';
        break;
      case 404:
        errorMsg = 'No se encontró el servicio solicitado.';
        break;
      case 500:
        errorMsg = 'Ocurrió un problema con el servidor.';
        break;
      default:
        errorMsg = 'Ocurrió algo inesperado.';
        break;
    }

    return throwError({ error: errorMsg });
  }
}
